import { NfcIcon } from './NfcIcon';

/**
 * author: Contributors
 * id 961106B7-BD56-462C-936C-E2CDC83051B5
 * name nfc
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nfc.svg
 * tags
 * - Brand / Logo 
 */
export const NearFieldCommunicationIcon = NfcIcon;
export default NearFieldCommunicationIcon